export const COMPONENT_NAME = "ui-textarea";
